// extracted by mini-css-extract-plugin
export default {"container_form":"styles_container_form__APm9t","toggle":"styles_toggle__0szby"};